import client from "../client";

export interface GetDepositWithdrawHistoryRequest {
  limit?: number;
  offset?: number;
}

export interface DepositWithdrawHistoryItem {
  transaction_id?: number;
  transaction_type?: "deposit" | "withdraw"; // สำคัญ! แยกประเภท
  reference_id?: string;
  status?: string;
  amount?: number;
  fee?: number;
  net_amount?: number;
  balance_before?: number;
  balance_after?: number;
  bank_name?: string;
  bank_account?: string;
  bank_account_name?: string;
  notes?: string;
  admin_notes?: string;
  processed_at?: string;
  completed_at?: string;
  created_at?: string;
  dest_bank_name?: string;
  dest_bank_account?: string;
  dest_bank_account_name?: string;
  qr_code?: string;
  promotion_type_id?: number | null;
  promotion_value?: number;
  free_credit?: number;
  external_transaction_id?: string;
}

export interface GetDepositWithdrawHistoryResponse {
  transactions?: DepositWithdrawHistoryItem[];
  total?: number;
  limit?: number;
  offset?: number;
}

export default function API(
  request?: GetDepositWithdrawHistoryRequest
): Promise<GetDepositWithdrawHistoryResponse> {
  return client
    .get(`payment_v2/deposit-withdraw/history`, { params: request })
    .then((response) => response.data);
}
